<template>
  <div class="contentDetails">
    <NavBar :navtitle="navtitle" :navBlock="navBlock" :pageBack="true"></NavBar>
    <div class="detailsContent">
      <div class="detailsTitle">
        <div class="detailsWrap"></div>
        <p>實名詳情</p>
      </div>
      <el-form>
        <el-form-item
          label="認證失敗原因:"
          v-show="userInfo.authorizationCode == 3 && userInfo.memo != null"
        >
          <input
            disabled
            class="el-input__inner blackColor"
            type="text"
            v-model="userInfo.memo"
          />
        </el-form-item>

        <el-form-item label="真實姓名:" v-show="userInfo.realName != null">
          <input
            maxlength="100"
            disabled
            class="el-input__inner blackColor"
            type="text"
            v-model="userInfo.realName"
          />
        </el-form-item>

        <el-form-item label="地區:" v-show="userInfo.region != null">
          <input
            maxlength="100"
            disabled
            class="el-input__inner blackColor"
            type="text"
            v-model="userInfo.region"
          />
        </el-form-item>

        <el-form-item label="證件號碼:" v-show="userInfo.idcardNumber != null">
          <input
            maxlength="100"
            disabled
            class="el-input__inner blackColor"
            type="text"
            v-model="userInfo.idcardNumber"
          />
        </el-form-item>

        <el-form-item label="手機號碼:" v-show="userInfo.phoneNumber != null">
          <input
            maxlength="100"
            disabled
            class="el-input__inner blackColor"
            type="text"
            v-model="userInfo.phoneNumber"
          />
        </el-form-item>

        <el-form-item
          label="身份證照片:"
          v-show="userInfo.frontImg[0] != null || userInfo.backImg[0] != null"
        >
          <div class="voucherBlock">
            <div
              class="voucherWrap previewFrontImg"
              v-viewer="{ movable: false }"
            >
              <img
                class="voucherImg"
                v-for="(src, index) in userInfo.frontCompress"
                :src="src"
                :key="index"
                alt=""
                ref="img1"
              />
              <span
                v-show="userInfo.frontImg[0] != null"
                @click="previewFrontImg()"
                >查看大圖</span
              >
              <span @click="rotate(1,-90)">左转</span>
              <span @click="rotate(1,90)">右转</span>
            </div>

            <div
              class="voucherWrap previewBackImg"
              v-viewer="{ movable: false }"
            >
              <img
                class="voucherImg"
                v-for="(src, index) in userInfo.backCompress"
                :src="src"
                :key="index"
                alt=""
                ref="img2"
              />
              <span
                v-show="userInfo.backImg[0] != null"
                @click="previewBackImg()"
                >查看大圖</span
              >
              <span @click="rotate(2,-90)">左转</span>
              <span @click="rotate(2,90)">右转</span>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="bottomBtn">
        <!-- 待审核 -->
        <div
          v-show="memberStatus === 2"
          class="btn auditBtn"
          @click="auditPass()"
        >
          <img src="@/assets/images/common/auditPass.png" alt="" />
          <p>審核通過</p>
        </div>

        <div
          v-show="memberStatus === 2"
          class="btn borderBtn auditBtn"
          @click="noauditFailed()"
        >
          <img src="@/assets/images/common/auditFailed.png" alt="" />
          <p>審核不通過</p>
        </div>

        <div
          v-show="memberStatus === 1"
          class="btn borderBtn auditBtn"
          @click="auditFailed()"
        >
          <img src="@/assets/images/common/auditFailed.png" alt="" />
          <p>删除实名认证</p>
        </div>
      </div>
    </div>
    <div v-if="noAuth" class="propWrap">
      <div class="prop-content mobile_show">
        <i
          style="margin:0.1rem"
          class="iconfont icon-close fr hand"
          @click="noAuth = false"
        ></i>
        <p class="prop-title normal_font">提示</p>
        <el-input
          class="authTextarea"
          type="textarea"
          :rows="2"
          placeholder="請輸入審核失敗原因"
          v-model="noAuthText"
        >
        </el-input>
        <div class="bottomBtn">
          <!-- <div class="btn borderBtn" @click="sureAuditFailed(1)">不寫原因並提交</div> -->
          <div class="btn hand new_btn" @click="sureAuditFailed(2)">
            確認提交
          </div>
        </div>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "會員  /  實名認證",
      navtitle: "認證詳情",
      email: this.$route.query.email,
      noAuth: false,
      authCode: "",
      userInfo: {
        authorizationCode: "", //認證狀態
        memo: "", //認證失敗原因
        realName: "",
        region: "",
        idcardNumber: "",
        phoneNumber: "",
        frontImg: [],
        backImg: [],
        frontCompress:[],
        backCompress:[],
      },
      memberStatus: "",
      previewImgUrl: "",
      noAuthText: "", //審核失敗原因
      dialogVisible: false,
      initRotate1:0,
      initRotate2:0,
    };
  },
  created() {
    let _this = this;
    _this.getAuthDetails();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取用户信息详情
    getAuthDetails() {
      let _this = this;
      _this
        .$get(
          `/request/authentication/getAuthDetail?email=${_this.email}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            _this.userInfo = {
              authorizationCode: res.data.authorizationCode,
              memo: res.data.memo,
              realName: res.data.realName,
              region: res.data.authenticationAddress,
              idcardNumber: res.data.idCardNumber,
              phoneNumber: res.data.mobile1,
              frontImg: [res.data.frontView],
              backImg: [res.data.backView],
              frontCompress:[res.data.frontViewCompress],
              backCompress:[res.data.backViewCompress]
            };
            _this.memberStatus = Number(res.data.authorizationCode);
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },

    // 审核通过
    auditPass() {
      let _this = this;
      _this
        .$confirm("是否同意此用戶認證信息?", "提示信息", {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          _this
            .$get(
              `/request/authentication/AlAuthentication?email=${_this.email}`,
              {},
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("操作成功", "success", function() {
                  _this.dialogVisible = false;
                  _this.$router.push("/certificationList");
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        })
        .catch(() => {});
    },
    noauditFailed() {
      let _this = this;
      _this.noAuth = true;
    },
    sureAuditFailed(e) {
      let _this = this;
      // 填寫審核不通過原因
      if (e === 2) {
        if (_this.noAuthText === "") {
          _this.$warnMessage("請輸入審核失敗原因");
          return false;
        }
        if (_this.$getCaption(_this.noAuthText)) {
          _this.$warnMessage("審核失敗原因不能包含非法字符");
          return false;
        }
        _this.auditFailed(true);
        // setTimeout(() => {
        //   _this.noAuth = false;
        // }, 1500);
      } else {
        // 不填寫審核不通過原因
        _this.auditFailed(false);
        // setTimeout(() => {
        //   _this.noAuth = false;
        // }, 1500)
      }
    },
    // 刪除實名認證、審核不通過
    auditFailed(memo) {
      let _this = this;
      let memoText = "";
      _this
        .$confirm("是否拒絕此用戶認證信息?", "提示信息", {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          if (memo == true) {
            memoText = _this.noAuthText;
          }
          _this
            .$get(
              `/request/authentication/deAuthentication?email=${_this.email}&memo=${memoText}`,
              {},
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.noAuth = false;
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("操作成功", "success", function() {
                  _this.dialogVisible = false;
                  _this.$router.push("/certificationList");
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        })
        .catch(() => {});
    },

    // 预览身份证正面照
    previewFrontImg() {
      let _this = this;
      const frontViewer = _this.$el.querySelector(".previewFrontImg").$viewer;
      frontViewer.show();
    },
    // 预览身份证反面照
    previewBackImg() {
      let _this = this;
      const backViewer = _this.$el.querySelector(".previewBackImg").$viewer;
      backViewer.show();
    },
    // 转
    rotate(digit,direction){
      if (digit === 1) {
          this.initRotate1 += direction;
      } else if (digit === 2) {
          this.initRotate2 += direction;
      }
      const imgElement = this.$refs['img' + digit][0]
      if (imgElement) {
        const currentRotation = digit === 1 ? this.initRotate1 : this.initRotate2;
        const scale = currentRotation % 180 ? 0.75 : 1 
        imgElement.style.transform = `rotate(${currentRotation}deg) scale(${scale})`;
        imgElement.style.transition = 'transform 0.5s';
      }
    },
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.contentDetails {
  .detailsContent {
    input:disabled {
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;
    }

    input.newsType {
      background: none;
      line-height: 40px;
      height: 40px;
      color: #606266;
    }

    .voucherBlock {
      display: flex;
      justify-items: start;
      align-items: center;

      .voucherWrap {
        // width: 1rem;
        // height: 1rem;
        .voucherImg {
          width: 22vw;
          height: 16.5vw;
          // width: 1rem;
          // height: 1rem;
          display: block;
          object-fit: cover;
        }
      }

      .voucherWrap:first-child {
        margin-right: 20px;
      }

      span {
        display: inline-block;
        margin-left: 0.2rem;
        cursor: pointer;
      }
    }
  }

  .propWrap {
    .prop-content {
      height: 400px;
      overflow: auto;

      .authTextarea {
        padding: 0.8rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/authDetails.vue